import moment from 'moment';
import { dateFormat } from '../../../constants';
import { getStopApi } from '../../../services/StopApi/StopApi';

export const getCdcrList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data.tblOSAP;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json
    };
  });
};


export const getCdcrReportData = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data.tblOSAPRpt;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json
    };
  }).catch((e) => alert(e));
};
